import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
//Antd
import { Card, Layout } from "antd";
//components
import * as ducks from "../../../redux/aspirante/aspiranteDucks";
import * as catDuck from "../../../redux/aspirante/catalogoDucks";
import { DatosContacto } from "../../../components/Public/Aspirante";
import { DatosPersonales } from "../../../components/Public/Aspirante";
//Utils
import { Ast } from "../../../utils/funciones";

/**
 * Pantalla principal del registro de la información personal del aspirante.
 * @return {JSX.Element}
 */
export const InfoPersonalPage = ({ form }) => {
  const dispatch = useDispatch();
  const isMounted = useRef(true);

  //useEffect que valida si el componente está montado en la App.
  useEffect(() => {
    return () => {
      isMounted.current = false; //Desmontar el componente
    };
  }, []);

  //useEffect que limpia el state de aspirante y carga el catalogo de Estados.
  useEffect(() => {
    //Se limpia el state
    dispatch(ducks.cleanAspirante());
    //Se carga el catálogo de estados
    isMounted.current && dispatch(catDuck.getCatEstados());
    isMounted.current && dispatch(catDuck.getCatEstadosExt());
    //Medios comunicación 
    isMounted.current && dispatch(catDuck.getCatMediosComunicacion());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <div className="site-layout-content">
        <label className="requeridos">
          Los campos con ( <Ast />) son necesarios.
        </label>
        <div className="mt-2">
          <Card id="registro-card">
            {/* Datos del aspirante */}
            <DatosPersonales isRegistro={true} form={form} />
          </Card>
        </div>

        <div className="mt-2">
          <Card id="registro-card" title="Domicilio personal">
            {/* Direccion del aspirante */}
            <DatosContacto form={form} />
          </Card>
        </div>
      </div>
    </Layout>
  );
};
